import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA} from "@angular/material/dialog";

@Component({
  selector: 'app-modal-importacao-lote',
  templateUrl: './modal-importacao-lote.component.html',
  styleUrls: ['./modal-importacao-lote.component.scss']
})
export class ModalImportacaoLoteComponent implements OnInit {

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit(): void {
    this.data = 'Para verificar os detalhes do arquivo, verifique na tela de importação em lote.';
  }

}
